import { combineReducers } from 'redux';

import { routerReducer } from 'react-router-redux';
import db from './dbReducer';
import newBucketPage from './newBucketPageReducer';
import newAsset from './newAssetReducer';
import currentOrganizations from './currentOrganizationsReducer';
import organizationSettings from './organizationSettingsReducer';
import reportPage from './reportPageReducer';
import membersOfBuckets from './membersOfBucketsReducer';
import bucketSettings from './bucketSettingsReducer';
import currentUser from './currentUserReducer';
import appDialog from './appDialogReducer';
import bucketsByOrganization from './bucketsByOrganizationReducer';
import snackbar from './snackbarReducer';
import { userSearch, searchOrganizationUsersForBucket, assetSearch } from './searchReducer';
import { usersByOrg, usersByBuckets } from './usersReducer';
import { invitationsByOrg } from './invitationsReducer';
import {
    organizationBucketsFilter,
    organizationMembersFilter,
    bucketMembersFilter,
} from './filterReducer';
import assets from './assetsReducer';
import tags from './tagsReducer';
import batchActions from './batchActionsReducer';
import exportProjectImages from './exportProjectImagesReducer';

const rootReducer = combineReducers({
    router: routerReducer,
    currentUser,
    currentOrganizations,
    organizationBucketsFilter,
    usersByOrg,
    invitationsByOrg,
    usersByBuckets,
    bucketsByOrganization,
    newBucketPage,
    organizationSettings,
    reportPage,
    appDialog,
    membersOfBuckets,
    bucketSettings,
    db,
    userSearch,
    organizationMembersFilter,
    bucketMembersFilter,
    searchOrganizationUsersForBucket,
    snackbar,
    assets,
    newAsset,
    tags,
    assetSearch,
    batchActions,
    exportProjectImages,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js